import React from 'react';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from './ui/sidebar';
import { Link } from './ui/link';
import { ArrowLeft, PanelLeft } from 'lucide-react';
import { cn } from '../lib/utils';
import { useLocale } from '../contexts/LocaleContext';
import logoUrl from '../assets/logos/SVG/POSITIVO/logo scribane_positivo reducido h adjusted.svg?url';

export const PublicLinkSidebar: React.FC = () => {
  const { state, isMobile, openMobile, setOpenMobile, toggleSidebar } = useSidebar();
  const { t } = useLocale();
  const isCollapsed = isMobile ? !openMobile : state === 'collapsed';

  const handleMobileNavigation = (): void => {
    if (isMobile) {
      setOpenMobile(false);
    }
  };

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            {isCollapsed ? (
              <SidebarMenuButton
                tooltip={t('toggle_sidebar')}
                className="!justify-center !text-center"
                onClick={toggleSidebar}
                aria-label={t('toggle_sidebar')}
              >
                <PanelLeft className="h-6 w-6" />
                <span className="sr-only">{t('toggle_sidebar')}</span>
              </SidebarMenuButton>
            ) : (
              <div className="flex items-center gap-1 w-full">
                <SidebarMenuButton asChild tooltip="Scribane" className="flex-1">
                  <Link to="/" onClick={handleMobileNavigation} className="flex items-center w-full h-full py-0">
                    <img src={logoUrl} alt="Scribane" className="h-8 w-auto min-w-[150px]" />
                  </Link>
                </SidebarMenuButton>
                <SidebarMenuButton
                  tooltip={t('toggle_sidebar')}
                  className="!justify-center !text-center !pr-1"
                  onClick={toggleSidebar}
                  aria-label={t('toggle_sidebar')}
                >
                  <PanelLeft className="h-6 w-6" />
                  <span className="sr-only">{t('toggle_sidebar')}</span>
                </SidebarMenuButton>
              </div>
            )}
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip={t('back_to_home') || 'Back to home'} className={cn(isCollapsed && '!justify-center !text-center !gap-0')}>
                  <Link to="/" onClick={handleMobileNavigation} className={cn(isCollapsed && 'flex items-center justify-center w-full h-full')}>
                    {isCollapsed ? (
                      <ArrowLeft className="h-6 w-6" />
                    ) : (
                      <>
                        <ArrowLeft className="h-6 w-6" />
                        <span>{t('back_to_home') || 'Back to home'}</span>
                      </>
                    )}
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};

